import { render, staticRenderFns } from "./Federation.vue?vue&type=template&id=5c51eb7a&scoped=true"
import script from "./Federation.vue?vue&type=script&lang=js"
export * from "./Federation.vue?vue&type=script&lang=js"
import style0 from "./Federation.vue?vue&type=style&index=0&id=5c51eb7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51eb7a",
  null
  
)

export default component.exports